import React from 'react';

const parseAvailability = value => {
  const text = String(value ?? '').trim();
  if (!text || /n\/a|—|--/i.test(text)) return null;

  const full = text.match(/(\d+)\s*(?:Full|F)\b/i);
  const partial = text.match(/(\d+)\s*(?:Partial|P)\b/i);

  if (full) {
    return {
      full: Number(full[1]),
      partial: partial ? Number(partial[1]) : 0,
    };
  }

  const n = Number(text);
  return Number.isFinite(n) ? { full: n, partial: 0 } : null;
};

const backfillClass = value => {
  const counts = parseAvailability(value);
  if (!counts) return 'pub-neutral';
  if (counts.full === 0 && counts.partial > 0) return 'pub-warn';
  if (counts.full === 0) return 'pub-bad';
  if (counts.full <= 3) return 'pub-warn';
  return 'pub-good';
};

const resultClass = value => {
  const text = String(value || '');
  if (/No Direct Impact/i.test(text)) return 'pub-neutral';
  if (/Partial Backfill Only/i.test(text)) return 'pub-warn';
  if (/No Backfill|No Candidates|Found/i.test(text) && !/Available/i.test(text)) return 'pub-bad';
  if (/Backfill Candidates Available|Available/i.test(text)) return 'pub-good';
  return '';
};

const statusClass = value => {
  const text = String(value || '');
  if (/\+?MCB|Mandatory Callback|Mando/i.test(text)) return 'pub-bad';
  return '';
};

export default function DataTable({ rows }) {
  return (
    <div className="pub-table-wrap">
      <table className="pub-table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
            <th>Hours</th>
            <th>Needed Rank</th>
            <th>Backfill (Full / Partial)</th>
            <th>Names</th>
            <th>Type</th>
            <th>List Time</th>
            <th>Roster Time</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          {(rows || []).map((r, i) => (
            <tr key={i}>
              <td>{r.date}</td>
              <td className={statusClass(r.employeeStatus)}>{r.employeeStatus}</td>
              <td>{r.hours}</td>
              <td>{r.neededRank || '—'}</td>
              <td className={backfillClass(r.backfillCandidates)}>{r.backfillCandidates}</td>
              <td className="left">{r.candidateNames || '—'}</td>
              <td>{r.candidateType || '—'}</td>
              <td>{r.candidatePrintTime || '—'}</td>
              <td>{r.rosterPrintTime || '—'}</td>
              <td className={resultClass(r.result)}>{r.result}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
